import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimePlayIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.21 11.57L4.73999 1.69C4.41999 1.49 3.96999 1.74 3.97999 2.12V21.88C3.96999 22.26 4.41999 22.51 4.73999 22.31L21.21 12.43C21.53 12.25 21.53 11.75 21.21 11.57Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimePlayIcon.displayName = 'TimePlayIcon';
